import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { apiResponse } from '../../models/apiResponse';
import { 
  StudentDocumentVaultResponse
} from '../../models/student-document-vault/student-document-vault';

@Injectable({
  providedIn: 'root'
})
export class StudentDocumentVaultService {
  constructor(private genericService: GenericService) {}

  getDocumentVaults(pageNumber: number = 1, pageSize: number = 10, category?: number, documentId?: string, statusFilter: number = 1): Observable<apiResponse<StudentDocumentVaultResponse[]>> {
    const params: any = { 
      pageNumber: pageNumber.toString(), 
      pageSize: pageSize.toString(),
      statusFilter: statusFilter.toString()
    };
    if (category) {
      params.category = category.toString();
    }
    if (documentId) {
      params.documentId = documentId;
    }
    return this.genericService.get('student/document-vault', { params });
  }

  getStatusCounts(): Observable<apiResponse<any>> {
    return this.genericService.get('student/document-vault/status-counts');
  }

  getDocumentVaultById(id: string): Observable<apiResponse<StudentDocumentVaultResponse>> {
    return this.genericService.get(`student/document-vault/${id}`);
  }

  uploadDocumentVault(formData: FormData): Observable<StudentDocumentVaultResponse> {
    return this.genericService.postFormData('student/document-vault', formData);
  }

  updateDocumentVault(id: string, formData: FormData): Observable<StudentDocumentVaultResponse> {
    return this.genericService.putFormData(`student/document-vault/${id}`, formData);
  }

  deleteDocumentVault(id: string): Observable<boolean> {
    return this.genericService.delete(`student/document-vault/${id}`);
  }

  searchDocumentsByTitle(title: string): Observable<any> {
    return this.genericService.get('student/document-vault/search', { params: { title } });
  }

  getCategoryCounts(statusFilter: number = 1): Observable<apiResponse<any[]>> {
    return this.genericService.get('student/document-vault/category-counts', { params: { statusFilter: statusFilter.toString() } });
  }
}
